import * as actionTypes from '../actionTypes';

const state = {
  windowInnerWidth: window.innerWidth,
  isOnline: true,
  // 第一次操作已完成(目前藉由啟動碼已經有最後使用的時間來判定)
  isDoneFirstTime: false,
  tutorialsActiveKey: '',
};

function parameterReducer(globalState = state, action) {
  switch (action.type) {
    case actionTypes.SET_WINDOW_INNER_WIDTH:
      return {
        ...globalState,
        windowInnerWidth: action.width,
      };
    case actionTypes.IS_DONE_FIRST_TIME:
      return {
        ...globalState,
        isDoneFirstTime: action.isDone,
      };
    case actionTypes.POST_TUTORIALS_ACTIVE_KEY:
      return {
        ...globalState,
        tutorialsActiveKey: action.key,
      };
    case actionTypes.SET_IS_ONLINE:
      return {
        ...globalState,
        isOnline: action.isOnline,
      };
    default:
      return globalState;
  }
}

export { parameterReducer as default };
